import React from 'react';
import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Goal = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <div className="mid-complex">
                <div className="mid-complex__img">
                    <img src="/images/pic/mid/laptop.png" alt="" loading="lazy" />
                </div>
                <FullWrapper bigPaddings={true} className="mid-complex__wrapper">
                    <div className="mid-complex__grid">
                        <div className="mid-complex__content">
                            <CommonTitle className="mid-complex__title">Сложности</CommonTitle>
                            <CommonSmallTitle>Пандемия и&nbsp;онлайн-формат</CommonSmallTitle>
                            <CommonSmallText className="mid-complex__text">
                                Из-за пандемии нам пришлось адаптироваться под онлайн-формат
                                проведения дня открытых дверей. Важно было привести людей
                                на&nbsp;прямой эфир и&nbsp;собрать целевые заявки
                                на&nbsp;поступление. Но&nbsp;в&nbsp;отличие от&nbsp;прошлых лет,
                                в&nbsp;2020 можно подать документы только с&nbsp;помощью электронной
                                подачи на&nbsp;сайте Колледжа. Нужно всего лишь загрузить форму
                                заявления на&nbsp;поступление и&nbsp;заполнить небольшую анкету, как
                                было&nbsp;бы при офлайн-поступлении. Это намного упростило жизнь
                                людей, которым раньше нужно было привозить лично оригиналы
                                документов.
                            </CommonSmallText>
                            <br />
                            <CommonSmallText>
                                В&nbsp;целом сбор заявок в&nbsp;пандемию для нас ничем
                                не&nbsp;отличался от&nbsp;работы в&nbsp;прошлый год, мы&nbsp;также
                                привлекали людей с&nbsp;помощью основных инструментов:
                                таргетированной рекламы ВКонтакте и&nbsp;Instagram, контекстной
                                рекламы в&nbsp;Яндекс Директ и&nbsp;Google Ads. А&nbsp;еще
                                дополнительно запустили показы ролика о&nbsp;колледже
                                на&nbsp;YouTube.
                            </CommonSmallText>
                        </div>
                    </div>
                </FullWrapper>
            </div>
        </ScrollAnimation>
    );
};

export default Goal;
